import { arrayToThresholds } from "./arrayToThresholds";
import { getClosestValue } from "./getClosestValue";

function getDowntimeLabelByValue(value: number) {
  const threshold = getClosestValue(DOWNTIME_THRESHOLDS, value);
  const index = DOWNTIME_THRESHOLDS.indexOf(threshold);
  return DOWNTIME_LABELS[index];
}

function getDowntimeThresholdByValue(value: number) {
  return getClosestValue(DOWNTIME_THRESHOLDS, value);
}

const DOWNTIME_LABELS = [
  "maintenance:priority.select.downtime.slider.0",
  "maintenance:priority.select.downtime.slider.25",
  "maintenance:priority.select.downtime.slider.50",
  "maintenance:priority.select.downtime.slider.75",
  "maintenance:priority.select.downtime.slider.100",
];

const DOWNTIME_THRESHOLDS = arrayToThresholds(DOWNTIME_LABELS);

export function getDowntimeProps() {
  return {
    thresholds: DOWNTIME_THRESHOLDS,
    labels: DOWNTIME_LABELS,
    getDowntimeLabelByValue,
    getDowntimeThresholdByValue,
  };
}
